import axios from "axios";

const BASE_URL = "https://vas.worlinks.com/api/gamerClub/asiacell-d";

const AsiacellService = {
  
  // 🔹 antifraud?pageid=x
  antifraud: async (page) => {
    const res = await axios.get(`${BASE_URL}/antifraud?pageid=${page}`);
    return res.data;
  },

  // 🔹 POST subscribe (send pin)
  sendPinNonHeader: async (msisdn, AntiFrauduniqid) => {
    const body = {
      phone: msisdn,
      AntiFrauduniqid: AntiFrauduniqid
    };
    const res = await axios.post(`${BASE_URL}/subscribe`, body);
    return res.data;
  },

 
verifyNonheader: async (params) => {
  const body = {
    phone: params.phone,
    otp: params.otp,
    AntiFrauduniqid: params.AntiFrauduniqid || "",
    company: params.company || "",
    key: params.key || "",
  };

  const res = await axios.post(`${BASE_URL}/verify`, body);
  return res.data;
},

  // 🔹 GET check header
  getPhoneByHeader: async () => {
    const res = await axios.get(`http://aciq.gamerclub.live/checkheaderasiacell.php`);
    return res.data;
  },

  // 🔹 POST antifraud with header data (this returns script)
  getScript: async (headerData) => {
    const res = await axios.post(`${BASE_URL}/antifraud`, headerData);
    return res.data;
  },

  // 🔹 POST direct subscribe
  confirmSubscribe: async (body) => {
    const res = await axios.post(`${BASE_URL}/directSub`, body);
    return res.data;
  }
};

export default AsiacellService;
